import VideoTimelineEditorIcon from '@atlaskit/icon-lab/core/video-timeline-editor';
import * as React from 'react';

export function SvgTimelineEditor() {
  return <VideoTimelineEditorIcon label="" testId="ads-refreshed-icon" />;
}
